import {useCallback, useState} from 'react';

export function useModalControls(
  initState = false,
  {disabled}: {disabled?: boolean} = {},
) {
  const [isOpen, setIsOpen] = useState(initState);

  const openModal = useCallback(() => {
    if (disabled) return;
    setIsOpen(true);
  }, [disabled]);

  const closeModal = useCallback(() => {
    if (disabled) return;
    setIsOpen(false);
  }, [disabled]);

  const toggleModal = useCallback(() => {
    if (disabled) return;
    setIsOpen(value => !value);
  }, [disabled]);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    setIsOpen,
  };
}
